import React, { useEffect, useRef, useState } from "react";
import { Button, Dropdown, Form, Input, Modal, Select } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import remove from "../../../assets/svg/delete.svg";
import svg37 from "../../../assets/svg/svg37.svg";
import svg25 from "../../../assets/svg/svg25.svg";
import {
  fetchIdentities, 
} from "../../../features/fetch/fetchSlice";
import PhoneInput from "react-phone-input-2";

const { TextArea } = Input;
const CustomerFilterModal = ({
  isModalOpen,
  handleCancel,
  prodd,
  formData,
  setFormData,
  filters,
  setFilters,
}) => {
  const [form] = Form.useForm();
  const formRef = useRef(null);

  const dispatch = useDispatch();
  const navigate = useNavigate();
 
  const { activeOrganization } = useSelector((state) => state.obj);
  const items = [
    {
      label: "National ID",
      key: "National ID",
    },
    {
      label: "Phone Number",
      key: "Phone Number",
    },
    {
      label: "Email Address",
      key: "Email Address",
    },
  ];

  // const [filters, setFilters] = useState([]);

  const filteredItems = items.filter(
    (item) => !filters?.some((filter) => filter?.value === item?.key)
  );

  const settingItems = filteredItems?.map((item) => ({
    key: item?.key,
    label: (
      <div
        className="font-dmSans text-black font-[400] text-[19px] mt-[5%]"
        onClick={() => handleMenuItemClick(item?.key)}
      >
        {item?.label}
      </div>
    ),
  }));

  const handleMenuItemClick = (itemKey) => {
    if (itemKey === "National ID") {
      const newFilter = {
        type: "National ID",
        value: "National ID",
      };
      setFilters([...filters, newFilter]);
    } else if (itemKey === "Phone Number") {
      const newFilter = {
        type: "Phone Number",
        value: "Phone Number",
      };
      setFilters([...filters, newFilter]);
    } else if (itemKey === "Email Address") {
      const newFilter = {
        type: "Email Address",
        value: "Email Address",
      };
      setFilters([...filters, newFilter]);
    }
  };

  const removeFilter = (index) => {
    const updatedFilters = filters?.filter((_, idx) => idx !== index);
    setFilters(updatedFilters);
    setFormData((prevData) => {
      const updatedData = { ...prevData };
      if (filters[index].type === "National ID") {
        delete updatedData.usrNationalId;
      } else if (filters[index].type === "Phone Number") {
        delete updatedData.usrMobileNumber;
      } else if (filters[index].type === "Email Address") {
        delete updatedData.usrEmail;
      }
      return updatedData;
    });
  };

  // const [formData, setFormData] = useState();

  const onChange = async (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  function handleSelectChange(value, formName) {
    setFormData((prevData) => ({
      ...prevData,
      [formName]: value,
    }));
  }

  const handleNumberChange = (e) => {
    setFormData((prevData) => ({
      ...prevData,
      usrMobileNumber: String(e),
    }));
  };

  const onFinish = async (data) => {
    const res = await dispatch(
      fetchIdentities({
        url: "api/v2/users/fetch-Identities",
        usrNationalId: formData?.usrNationalId,
        usrMobileNumber: formData?.usrMobileNumber,
        usrEmail:formData?.usrEmail,
        usrStatus: "PENDING_APPROVAL",
        usrOrgId: activeOrganization?.orgId,
      })
    );
    if (res?.payload?.success) { 
      handleCancel();
    } else {
      toast.error(res.payload?.messages?.message);
    }
  };

  const handleClear = async () => {
    await setFilters([]);
    await setFormData({});
    await handleCancel();
  };
 

  return (
    <>
      <Modal
        className="!mt-[13%] filter-modal "
        title="New Account "
        open={isModalOpen}
        onCancel={handleCancel}
        width={800}
      >
        <Form
          layout="vertical"
          ref={formRef}
          name="control-ref"
          onFinish={onFinish}
          className="px-[15px]"
          style={{
            maxWidth: "100%",
          }}
          form={form}
        >
          <div className="flex justify-between text-black21 text-[18px] font-normal leading-[24px] font-dmSans mb-5">
            <div className="">Filters</div>
            <div className="cursor-pointer" onClick={handleClear}>
              Clear
            </div>
          </div>
          <div className="grid grid-cols-1">
            <span className="text-black21 text-[18px] font-normal leading-[24px] font-dmSans mt-5">
              All filters
            </span>
            {filters?.map((filter, index) => (
              <div
                key={index}
                className="flex flex-col items-start mt-4 w-full"
              >
                {filter.type === "National ID" && (
                  <div className="flex items-center w-full gap-x-2">
                    <Form.Item className="w-[100%]">
                      <Input
                        className="input"
                        name={`input-${index}`}
                        value={filter.value}
                        readOnly={true}
                      />
                    </Form.Item>
                    <Form.Item className="w-[100%]">
                      <Input
                        name="usrNationalId"
                        className="input"
                        onChange={onChange}
                        value={formData?.usrNationalId}
                        placeholder="Enter National ID."
                      />
                    </Form.Item>
                    <Form.Item className="w-[20%]">
                      <button onClick={() => removeFilter(index)}>
                        <img src={remove} alt="remove-icon" />
                      </button>
                    </Form.Item>
                  </div>
                )}
                {filter.type === "Phone Number" && (
                  <div className="flex items-center w-full gap-x-2">
                    <Form.Item className="w-[100%]">
                      <Input
                        className="input"
                        name={`input-${index}`}
                        value={filter.value}
                        readOnly={true}
                      />
                    </Form.Item>
                    <Form.Item className="w-[100%]">
                      <PhoneInput
                        name="usrMobileNumber"
                        value={formData?.usrMobileNumber}
                        onChange={handleNumberChange}
                        country="ke"
                        onlyCountries={["ke"]}
                        countryCodeEditable={false}
                        className="input rounded-[6px] border !border-[#cacaca] !h-[42px]"
                      />
                    </Form.Item>
                    <Form.Item className="w-[20%]">
                      <button onClick={() => removeFilter(index)}>
                        <img src={remove} alt="remove-icon" />
                      </button>
                    </Form.Item>
                  </div>
                )}

                {filter.type === "Email Address" && (
                  <div className="flex items-center w-full gap-x-2">
                    <Form.Item className="w-[100%]">
                      <Input
                        className="input"
                        name={`input-${index}`}
                        value={filter.value}
                        readOnly={true}
                      />
                    </Form.Item>
                    <Form.Item className="w-[100%]">
                      <Input
                        name="usrEmail"
                        className="input"
                        onChange={onChange}
                        value={formData?.usrEmail}
                        placeholder="Enter email address."
                      />
                    </Form.Item>
                    <Form.Item className="w-[20%]">
                      <button onClick={() => removeFilter(index)}>
                        <img src={remove} alt="remove-icon" />
                      </button>
                    </Form.Item>
                  </div>
                )}
              </div>
            ))}

            <div className="flex justify-between items-center">
              <Dropdown
                overlayStyle={{
                  width: "200px",
                }}
                trigger={"click"}
                menu={{ items: settingItems }}
                placement="bottom"
              >
                <Button
                  type="btn"
                  className="flex items-center w-[150px] bg-[#A3A2A7] text-white h-[45px] py-3 px-2
                 rounded-[10px] gap-x-1 mb-10 mt-5 !text-lexendS text-[16px] font-[500]"
                >
                  <img src={svg25} alt="add-icon" />
                  Add Filter
                  <img src={svg37} alt="svg37" />
                </Button>
              </Dropdown>

              {filters && filters?.length > 0 && (
                <div className="w-[150px]">
                  <button type="submit" className="cstm-btn-2">
                    submit
                  </button>
                </div>
              )}
            </div>
          </div>
        </Form>
      </Modal>
    </>
  );
};
export default CustomerFilterModal;
